import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  handleFormSubmit () {
    this.dispatch("turbo-form-submitted")
    this.element.reset()
  }
}
